import { CircularProgress, makeStyles } from "@material-ui/core";
import React, { useEffect } from "react";

import { FullSite } from "../../../../dtos/site";
import { hubConnection } from "../../../../signalr/provider";
import { StatsSummary } from "../StatsSummary";

import { SiteIssuesTable } from "./SiteIssuesTable";
import { useSiteIssues } from "./useSiteIssues";

const useStyles = makeStyles(() => ({
    row: {
        display: "flex",
        gap: "20px",
        alignItems: "center",
        flexWrap: "wrap",
    },
}));

interface Props {
    site: FullSite;
}

export function SiteIssues({ site }: Props) {
    const { issueCount, issuesByType, load, loading } = useSiteIssues(site);

    useEffect(() => {
        hubConnection.on("activeIssuesCountChanged", (siteId: number, count: number) => {
            if (siteId !== site.id) return;
            load();
        });

        return () => {
            hubConnection.off("activeIssuesCountChanged");
        };
    }, [site.id, load]);

    const classes = useStyles();

    return (<>
        <div className={classes.row}>
            <StatsSummary
                label="System Issues Detected"
                count={issueCount}
                attentionToCount={true}
            />
            {loading ? <CircularProgress size={28} /> : <></>}
        </div>

        <SiteIssuesTable issuesByType={issuesByType} />
    </>);
}
